import { render, staticRenderFns } from "./dataDetailModal.vue?vue&type=template&id=36a01efb"
import script from "./dataDetailModal.vue?vue&type=script&lang=js"
export * from "./dataDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports